import endpoints from '@app/src/api/endpoints'
import { FetchKey, useFetchResource } from '@app/src/api/fetchHooks'
import type { Category } from '@app/src/types/categories'
import type { Provider } from '@app/src/types/organizations'
import { Grid, Stack } from '@mui/material'
import React from 'react'
import CategoriesSection from './Details/CategoriesSection'
import CustomCategoriesSection from './Details/CustomCategoriesSection'
import OrganizationInformationSection from './Details/OrganizationInformationSection'
import SpendSection from './Details/SpendSection'

interface DetailsTabProps {
  provider: Provider
}

const DetailsTab: React.FC<DetailsTabProps> = ({ provider }) => {
  const { data: categories, isLoading: isCategoriesLoading } = useFetchResource<Category[]>({
    key: FetchKey.Category,
    endpoint: endpoints.category,
  })

  const hasCustomCategories = Boolean(categories?.length)

  return (
    <Grid container spacing={4} py={3}>
      <Grid item xs={12} md={6}>
        <Stack spacing={4}>
          <OrganizationInformationSection provider={provider} />
          <SpendSection provider={provider} />
        </Stack>
      </Grid>
      <Grid item xs={12} md={6}>
        <Stack spacing={4}>
          {isCategoriesLoading ? (
            <CategoriesSection provider={provider} />
          ) : hasCustomCategories ? (
            <>
              <CustomCategoriesSection provider={provider} categories={categories} />
              <CategoriesSection provider={provider} />
            </>
          ) : (
            <>
              <CategoriesSection provider={provider} />
              <CustomCategoriesSection provider={provider} categories={categories} />
            </>
          )}
        </Stack>
      </Grid>
    </Grid>
  )
}

export default DetailsTab
